module.exports = __webpack_public_path__ + "static/media/saxenda-green-bg-w-cercle.e4bd88fc.png";